
<component
  :is="as"
  class="image-container-card"
  v-bind="$attrs"
  v-on="$listeners"
>
  <div class="image-container">
    <img class="fade" v-lazy="{ src: image }" />
  </div>

  <div class="info-container">
    <slot />
  </div>
</component>
